import { PageLocatorMap } from '../types/PageLocatorMap';

export const loanDocumentSuccessPage = {
  footer: {
    root: 'loan-document-success-page.footer.root',
  },
  form: {
    h1: 'loan-document-success-page.form.h1',
    h2: 'loan-document-success-page.form.h2',
    root: 'loan-document-success-page.form.root',
    submitButton: 'loan-document-success-page.form.submit-button',
  },
  header: {
    drawerButton: 'loan-document-success-page.header.drawer-button',
    root: 'loan-document-success-page.header.root',
  },
} as const satisfies PageLocatorMap;
